export const PROJECT_DISCUSSIONS_QUERY_KEY = (projectId) => ['projects', projectId, 'discussion'];

export const BLOCKER_DISCUSSIONS_QUERY_KEY = (projectId, blockerId, taskId = null) => [
    'projects',
    projectId,
    'blockers',
    blockerId,
    'discussion',
    taskId,
];

